export default __webpack_public_path__ + "static/event7-5d4edfc30ea31feb7d4f42e2e296f219.jpg";